import { bigIntDividePresision } from '../consts';

export const bigIntFraction = (small: bigint, big: bigint): number => {
  return Number((small * bigIntDividePresision) / big) / Number(bigIntDividePresision);
};
